import { useFirestoreLoaded } from '../../firebase/useFirestore'
import MultiSelect from '../common/MultiSelect'
import { mechanismCategoryLabels } from '../../helpers/dataHelpers/mechanismCategories'
import useArrayLinkToggle from '../../hooks/useArrayLinkToggle'

/**
 * Link picker: which mechanisms belong to this effect or activity — the
 * inverse of SelectMechanismEffects / SelectMechanismActivities. The link
 * itself lives on the MECHANISM side (TocMechanisms.Effect[] / .Activity[],
 * by ID, not docid), so toggling here writes to the toggled mechanism's doc,
 * never to the effect or activity.
 *
 * @param {object} props
 * @param {string} props.targetId - ID of the effect or activity whose mechanism links are edited.
 * @param {'Effect' | 'Activity'} props.field - Link array on TocMechanisms that holds targetId.
 */
const SelectLinkedMechanisms = ({ targetId, field }) => {
    const [mechanisms, loaded] = useFirestoreLoaded('TocMechanisms')
    const toggleLink = useArrayLinkToggle()

    const label = (m) => m.Title || mechanismCategoryLabels[m.Category] || 'Naamloos mechanisme'

    const linked = (m) => Array.isArray(m[field]) && m[field].includes(targetId)
    const selected = (mechanisms || []).filter(linked).map((m) => m.ID)

    const byId = (mechanisms || []).reduce((acc, m) => {
        acc[m.ID] = m
        return acc
    }, {})

    const toggle = (id, isSelected) => {
        const mechanism = byId[id]
        if (!mechanism) return
        toggleLink({
            collection: 'TocMechanisms',
            docid: mechanism.docid,
            field,
            value: targetId,
            isSelected,
        })
    }

    const options = (mechanisms || []).map((m) => ({ id: m.ID, label: label(m) }))

    return (
        <MultiSelect
            selected={selected}
            options={options}
            onToggle={toggle}
            loaded={loaded}
            renderSelected={(id) => <span>{byId[id] ? label(byId[id]) : id}</span>}
            addLabel='+ Mechanisme toevoegen'
            emptyLabel='Geen mechanisme(n) gekoppeld'
            emptyOptionsLabel='Geen mechanismen beschikbaar'
            removeAriaLabel='Verwijder mechanisme'
        />
    )
}

export default SelectLinkedMechanisms
